// extracted by mini-css-extract-plugin
export var footerMedia = "socialMedia-module--footerMedia--VL6Zt";
export var footerMediaLeft = "socialMedia-module--footerMediaLeft--Q17mT";
export var footerMediaRight = "socialMedia-module--footerMediaRight--fzxec";
export var headerMedia = "socialMedia-module--headerMedia--I8TLE";
export var leftMediaThemeDark = "socialMedia-module--leftMediaThemeDark--qs6kY";
export var leftMediaThemePink = "socialMedia-module--leftMediaThemePink--BqzZt";
export var leftMediaThemeWhite = "socialMedia-module--leftMediaThemeWhite--wSVJ-";
export var rightMediaThemeDark = "socialMedia-module--rightMediaThemeDark--z55c2";
export var rightMediaThemePink = "socialMedia-module--rightMediaThemePink--7He5M";
export var rightMediaThemeWhite = "socialMedia-module--rightMediaThemeWhite--e6dm+";
export var socialMediaFix = "socialMedia-module--socialMediaFix--o0XfA";
export var socialMediaNormal = "socialMedia-module--socialMediaNormal--rMclB";